/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

import './LetterGeneration.css';
import { fonts, themes } from '../../common/themes/themes';
import { useAppSelector } from '../../infra/hooks';
import GeneratedLettersController from '../../domain/letterGeneration/GeneratedLetters/GeneratedLettersController';
import AppliedLettersController from '../../domain/letterGeneration/AppliedLetters/AppliedLettersController';
import { useTranslate } from '../../hooks';

const LetterGenerationPresenter: React.FC = () => {
  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);
  const { translate, language } = useTranslate();

  return (
    <Grid
      container
      style={{
        height: '100%',
        marginTop: '4em',
        paddingRight: isHRView && language === 'ar' ? '1em' : '8em',
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          marginTop: isHRView ? '-3em' : '',
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            backgroundColor: '#F5F5FA',
            width: '100%',
            height: 'auto',
            paddingLeft: '1.75em',
            marginRight: language == 'ar' ? '6em' : '',
          }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            sx={{
              display: 'flex',
              padding: '20px',
              flexWrap: 'wrap',
            }}
          >
            <Box>
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  sx={{
                    width: '100%',
                    marginTop: '1.75em',
                    padding: '1em',
                  }}
                >
                  <Box
                    style={{
                      width: 'auto',
                      height: 'auto',
                      background: '#FFFFFF 0% 0% no-repeat padding-box',
                      borderRadius: '10px',
                      opacity: '1',
                      display: 'flex',
                      flexDirection: 'row',
                      paddingTop: '1em',
                      paddingBottom: '1em',
                      paddingLeft: '1em',
                      paddingRight: '1em',
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: fonts.fontFamily,
                        fontSize: fonts.header,
                        color: themes.blackDefault,
                        fontWeight: 'bold',
                      }}
                    >
                      {translate('Letter Generation')}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>

              <Grid
                container
                style={{
                  width: '92vw',
                  display: 'flex',
                  flexWrap: 'nowrap',
                }}
                spacing={2}
              >
                <Grid item xs={4} sm={4} md={4} lg={4}>
                  <AppliedLettersController />
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={4}>
                  <GeneratedLettersController />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LetterGenerationPresenter;
